import {connect} from "react-redux";
import React, {useEffect} from "react";
import Wrapper from "../layout/Logged/Wrapper";
import {downloadPaymentReport, me} from "../actions/Profile";
import LoadingPanel from "../components/LoadingPanel";
import {PrimaryHeader} from "../components/Headers/PrimaryHeader";
import PaymentCollectionTable from "../components/PaymentCollection/PaymentCollectionTable";
import Grid2 from '@mui/material/Grid2';

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PaymentCollections = ({
	profile_data = [],
	history = {},
	profile_loading = false,
	me = () => {},
	downloadPaymentReport = () => {},
}) => {

	useEffect(() => {
		me();
	}, [me]);

	if (profile_loading) {
		return (
			<Grid2
				size={{
					xs: 12, sm: 12, md: 12, lg: 12, xl: 12,
				}}
				style={{
					width: "100%",
				}}
				container
			>
				<LoadingPanel/>
			</Grid2>
		);
	}

	return (
		<Wrapper history={history} profile_data={profile_data}>
			<Grid2>
				<PrimaryHeader
					backIcon
					helpIcon
				>
					Payment Collections
				</PrimaryHeader>
				<PaymentCollectionTable
					profile_data={profile_data}
					profile_loading={profile_loading}
					downloadPaymentReport={downloadPaymentReport}
				/>
			</Grid2>
		</Wrapper>
	);
};

export default connect(
	(state) => ({
		...state.Profile,
	}),
	(dispatch) => ({
		me: () => dispatch(me()),
		downloadPaymentReport: (scheduleId) => dispatch(downloadPaymentReport(scheduleId)),
	})
)(PaymentCollections);
